import React from "react";
import ReactApexChart from "react-apexcharts";
import ExportButton from "components/Reports/ExportCSV";
import { Box } from "@chakra-ui/react";

class LineChart extends React.Component {
  constructor(props) {
    super(props);

    const { data = [] } = props;
    const { labels, values } = this.transformData(data);

    this.state = {
      chartData: [
        {
          name: "Entries",
          data: values,
        },
      ],
      chartOptions: {
        chart: {
          type: "area",
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        xaxis: {
          categories: labels,
          labels: {
            style: { colors: "#A0AEC0" },
          },
          axisBorder: { show: true },
          axisTicks: { show: true },
          title: {
            text: "Date",
            style: { color: "#A0AEC0" },
          },
        },
        yaxis: {
          labels: {
            style: { colors: "#A0AEC0" },
          },
          title: {
            text: "Number of Entries",
            style: { color: "#A0AEC0" },
          },
        },
        grid: {
          borderColor: "#E2E8F0",
          strokeDashArray: 4,
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          theme: "light",
          x: {
            format: "dd MMM",
          },
          y: {
            formatter: (val) => `${val} entries`,
          },
        },
      },
    };
  }

  transformData = (data) => {
    const sliced = data.slice(0, 20);
    const labels = sliced.map((item) =>
      new Date(item.date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      })
    );
    const values = sliced.map((item) => item.count || 0);
    return { labels, values };
  };

  formatChartDataForExport = () => {
    const { categories } = this.state.chartOptions.xaxis;
    return this.state.chartData[0].data.map((value, index) => ({
      Label: categories[index],
      Value: value,
    }));
  };

  render() {
    const { showExportButton, fileName } = this.props;

    return (
      <Box position="relative" width="100%" height="100%">
        {showExportButton && (
          <Box position="absolute" top="-80px" right="10px" zIndex="1">
            <ExportButton
              data={this.formatChartDataForExport()}
              fileName={fileName || "chart_data"}
            />
          </Box>
        )}
        <ReactApexChart
          options={this.state.chartOptions}
          series={this.state.chartData}
          type="area"
          height="300"
        />
      </Box>
    );
  }
}

export default LineChart;
